import axios, { AxiosPromise, Canceler, CancelTokenStatic } from 'axios';
import { IBusinessRule } from '../../../@types/model/masterData/businessRule/businessRule';
import { IBusinessRuleUpsert } from '../../../@types/model/masterData/businessRule/businessRuleUpsert';

export default class BusinessRuleHttpService {
    private static readonly CancelToken : CancelTokenStatic = axios.CancelToken;
    /**
     * Allows you to cancel list request
     */
    public static cancelGetList ?: Canceler;

    public static getList(divisionIds : Array<number>) : AxiosPromise<Array<IBusinessRule>> {
        if (this.cancelGetList) {
            this.cancelGetList('GET Canceled');
            this.cancelGetList = undefined;
        }

        return axios.get(`${API_URL}/v1/MasterData/BusinessRule/GetList`, {
            params: {
                divisionIds
            },
            paramsSerializer: {
                indexes: null
            },
            cancelToken: new this.CancelToken((c) => {
                this.cancelGetList = c;
            }),
        });
    }

    public static upsert = (upsert : IBusinessRuleUpsert, type : 'Add' | 'Edit') : AxiosPromise<IBusinessRule> => {
        return axios.post(`${API_URL}/v1/MasterData/BusinessRule/${type}`, upsert);
    }

    public static delete = (id : number) : AxiosPromise<IBusinessRule> => {
        return axios.delete(`${API_URL}/v1/MasterData/BusinessRule/Delete`, {
            params: { id },
        });
    }
}